import React from 'react';
import { FaCheck, FaTimes, FaClock, FaTrophy } from 'react-icons/fa';
import { MdVerified } from "react-icons/md";
const DashboardSummary = ({ alldata }) => {

  const excludedStatuses = ['Approved', 'Contacted', 'Rejected', 'Employee'];

  const da = alldata
    .filter(item => !excludedStatuses.includes(item.fld_onboardstatus))
    .map(item => item.fld_onboardstatus);

  console.log("dadad", da);


  const total = alldata.length;
  const approved = alldata.filter(item => item.fld_onboardstatus === "Approved").length;
  const contacted = alldata.filter(item => item.fld_onboardstatus === 'Contacted').length;
  const pending = alldata.filter(item => item.fld_onboardstatus === 'Pending').length;
  const rejected = alldata.filter(item => item.fld_onboardstatus === 'Rejected').length;
  const employee = alldata.filter(item => item.fld_onboardstatus === 'Employee').length;
  const blocked = alldata.filter(item => item.fld_onboardstatus === 'Blocked').length;

  const dataCards = [
    { icon: <FaTrophy />, label: 'Total', value: total, color: '#c16d18' },       // Highlight color
    { icon: <MdVerified />, label: 'Employee', value: employee, color: 'rgb(249, 190, 75)' },    // Neutral
    { icon: <FaCheck />, label: 'Completed', value: approved, color: 'rgb(153, 237, 138)' }, // Highlight color
    { icon: <FaClock />, label: 'Pending', value: pending+contacted, color: 'gray' },     // Light/neutral
    { icon: <FaTimes />, label: 'Rejected', value: rejected + blocked, color: 'rgb(246, 91, 96)' }, // Neutral
  ];


  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
      {dataCards.map((card, index) => (
        <div
          key={index}
          style={{
            // background: card.color,
            // color: 'white',
            border: `1px solid ${card.color}`,
            padding: '16px 24px',
            borderRadius: '8px',
            minWidth: '150px',
            flex: '1 0 150px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
          }}
        >
          <div style={{ fontSize: '24px', color: card.color }}>{card.icon}</div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '20px', fontWeight: 'normal', color: card.color }}>{card.value}</div>
            <div style={{ fontSize: '12px', opacity: 0.9, color: card.color }}>{card.label.toUpperCase()}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardSummary;
